import React from "react";
import ReactApexChart from "react-apexcharts";

class EmptyChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            series: [
                {
                    name: "MRR1",
                    data: [90, 21, 70, 25, 51, 71, 85],
                },
            ],
            options: {
                chart: {
                    height: 236,
                    type: 'line',
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    },
                },
                legend: {
                    show: false
                },
                stroke: {
                    curve: 'straight',
                    width: [0, 0],
                    colors: ["#c0c8d2", "#eeeeee"]
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    show: false
                },
                grid: {
                    borderColor: '#ebeef1',
                    row: {
                        colors: ['transparent', 'transparent'],
                        opacity: 0.5
                    },
                    padding: { top: 0, right: 0, bottom: 0, left: -10 },
                    xaxis: {
                        lines: {
                            show: true
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                },
                xaxis: {
                    categories: ['1', '2', '3', '4', '5', '6', '7'],
                    labels: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    }
                }
            },


        };
    }

    render() {
        return (
            <div id="chart">
                <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={236} />
            </div>
        );
    }
}

export default EmptyChart